export default __webpack_public_path__ + "static/blight-7b10ebfe719798062d9c3482a55ea919.jpg";